import { CollectionHandlers, CollectionUI, CollectionValues } from '../types';

export interface SaveToCollectionDrawerProps {
    collections: CollectionUI[];
    isCollectionsLoading: boolean;
    onSaveToExistentCollection: (id: string) => void;
    onClose: VoidFunction;
    values: CollectionValues;
    handlers: CollectionHandlers;
    step: BookmarkStep;
    onAddClick: VoidFunction;
    isNotRegistered: boolean;
    loadMore?: VoidFunction;
    isLoadingMore?: boolean;
}

export enum BookmarkStep {
    ADD_TO_NEW_COLLECTION = 'ADD_TO_NEW_COLLECTION',
    ADD_TO_EXIST_COLLECTION = 'ADD_TO_EXIST_COLLECTION',
}
